import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {endOfDay, startOfDay} from 'date-fns';
import moment from 'moment';

export const setFilters = createAsyncThunk(
  'patientHistoryFilters/setFilters',
  async (args: any) => {
    return args;
  },
);

const patientHistoryFilters = createSlice({
  name: 'patientHistoryFilters',
  initialState: {
    selectedFilters: {
      startDate: startOfDay(moment().subtract(5, 'days').toDate()).getTime(),
      endDate: endOfDay(new Date()).getTime(),
      staff: [],
      locations: [],
      types: [],
      status: ['completed', 'missing-values'],
    },
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(setFilters.fulfilled, (state, {payload}) => {
      Object.assign(state, {selectedFilters: payload});
    });
  },
});

export default patientHistoryFilters.reducer;
